<script setup>
import CaretDownIcon from '@iconify-vue/ph/caret-down';
import DownloadSimpleIcon from '@iconify-vue/ph/download-simple';
import FileCsvIcon from '@iconify-vue/ph/file-csv';
import FileXlsIcon from '@iconify-vue/ph/file-xls';
import { AnimatePresence, Motion } from 'motion-v';
import {
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuPortal,
    DropdownMenuRoot,
    DropdownMenuTrigger,
} from 'reka-ui';
import { ref } from 'vue';

const {
    csvExportCallback,
    xlsxExportCallback,
    disabled = false,
} = defineProps({
    csvExportCallback: {
        type: Function,
        required: false,
    },
    xlsxExportCallback: {
        type: Function,
        required: false,
    },
    disabled: {
        type: Boolean,
        required: false,
    },
});

const isOpen = ref(false);
</script>

<template>
    <DropdownMenuRoot v-model:open="isOpen" :modal="false">
        <DropdownMenuTrigger
            class="group flex items-center justify-center gap-2 rounded bg-indigo-600 px-3 py-1 text-sm text-white duration-150 outline-none hover:bg-indigo-950 disabled:cursor-not-allowed disabled:bg-indigo-600/60 disabled:hover:bg-indigo-600/60"
            :disabled="disabled"
        >
            <DownloadSimpleIcon class="size-4" />
            Exporter
            <CaretDownIcon
                class="size-4 duration-150 group-data-[state=open]:rotate-180"
            />
        </DropdownMenuTrigger>

        <DropdownMenuPortal>
            <DropdownMenuContent
                force-mount
                :side-offset="4"
                align="start"
                class="z-50"
            >
                <AnimatePresence>
                    <Motion
                        v-if="isOpen"
                        :initial="{ opacity: 0, y: -4 }"
                        :animate="{ opacity: 1, y: 0 }"
                        :exit="{ opacity: 0, y: -4 }"
                        :transition="{ duration: 0.15 }"
                        class="w-(--reka-dropdown-menu-trigger-width) overflow-hidden rounded border border-gray-300 bg-white shadow-sm"
                    >
                        <DropdownMenuItem
                            v-if="csvExportCallback"
                            class="flex w-full cursor-pointer items-center gap-2 px-3 py-1 text-left text-sm duration-150 outline-none hover:bg-indigo-600 hover:text-white data-[highlighted]:bg-indigo-600 data-[highlighted]:text-white"
                            @click="csvExportCallback()"
                        >
                            <FileCsvIcon class="size-4" />
                            CSV
                        </DropdownMenuItem>

                        <DropdownMenuItem
                            v-if="xlsxExportCallback"
                            class="flex w-full cursor-pointer items-center gap-2 px-3 py-1 text-left text-sm duration-150 outline-none hover:bg-indigo-600 hover:text-white data-[highlighted]:bg-indigo-600 data-[highlighted]:text-white"
                            @click="xlsxExportCallback()"
                        >
                            <FileXlsIcon class="size-4" />
                            XLSX
                        </DropdownMenuItem>
                    </Motion>
                </AnimatePresence>
            </DropdownMenuContent>
        </DropdownMenuPortal>
    </DropdownMenuRoot>
</template>
